import { ReactElement } from "react";
import { formatDate, DEFAULT_EMPTY_VALUE } from "util/statHelpers";

const DateColumn = ({ date }: { date: Date | undefined }): ReactElement => (
  <>{formatDate(date ?? DEFAULT_EMPTY_VALUE)}</>
);
export default DateColumn;
